<template>
  <div class="home">
    <b-container>
      <h1 class="text-center">Mold Testing &amp; Remediation for the Richmond, VA, Area</h1>
      <hr>
      
      <b-card-group deck>
        <b-card title="Mold &amp; Mildew">
          <b-card-body class="text-center">
            <p>We not only test and remediate the mold and mildew, but find the source and repair it.</p>
          </b-card-body>
        </b-card>
        <b-card title="Crawlspaces &amp; Basements">
          <b-card-body class="text-center">
            <p>Commonwealth Moisture &amp; Mold Specialists also provides crawlspace drainage and basement waterproofing.</p>
          </b-card-body>
        </b-card>
        <b-card title="Business Info">
          <b-card-body class="text-center">
            <p>Military and Service Discounts</p>
            <p>Indoor Air Quality Association Certified</p>
            <p>Certified Pesticide Applicator</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <br>
      <h2 class="text-center">Who We Are</h2>
      <p>Commonwealth Moisture &amp; Mold Specialists is a family-owned-and-operated business. We are certified in mold inspections and mold remediation, as well as a licensed contractor. We take pride in our customer service reputation and are constantly studying the latest and best products to address our customer's needs. Our experts have been correcting mold, crawlspace, and basement issues in the Richmond Tri-City area for more than 20 years. Call us at (804) 748-3099 today for a free inspection.</p>
      <p id="footnote-1"><sup>&dagger;</sup>Mold @ Centers for Disease Control: <a href="https://www.cdc.gov/mold/faqs.htm" target="_blank" rel="noopener noreferrer">https://www.cdc.gov/mold/faqs.htm</a></p>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }
}
</script>

<style scoped>
  .card-title {
    text-align: center;
  }
</style>

